module.exports = __webpack_public_path__ + "9e3e816228b686aed13061b18acdf3d9.svg";